import CodeFrameHub from './CodeFrameHub';

export default CodeFrameHub;
